import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// NOTE: withCredentials intentionally OFF — the infra proxy returns
// `Access-Control-Allow-Origin: *` which is incompatible with credentialed
// requests. We rely on the Bearer token (localStorage) attached below.
const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ce_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
